import mutations from './item/mutations';
import actions from './item/actions';
import getters from './item/getters';

const item = {
  namespaced: true,
  state: {
    item: {},
    errors: [],
    isLoading: false,
  },
  mutations,
  getters,
  actions,
};

export default item;
